import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const chargeAtPayGate = (cartId, tender) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/tender/paygate`,
    tender,
    publicAxiosHeader()
  );

export const sendCartToHostedPayment = (cartId) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/tender/hosted-payment`,
    null,
    publicAxiosHeader()
  );

export const getCart = (cartId) =>
  axios.get(`${getV1RootUrl()}/cart/${cartId}`, publicAxiosHeader());

export const addItem = (cartId, item) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/item`,
    item,
    publicAxiosHeader()
  );

export const createCart = (cart) =>
  axios.post(`${getV1RootUrl()}/cart`, cart, publicAxiosHeader());

export const updateCart = (cartId, cart) =>
  axios.put(`${getV1RootUrl()}/cart/${cartId}`, cart, publicAxiosHeader());

export const replaceTender = (cartId, tender) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/tender/replace`,
    tender,
    publicAxiosHeader()
  );

export const chargeCart = (cartId, data) =>
  axios.put(
    `${getV1RootUrl()}/cart/${cartId}/charge`,
    data,
    publicAxiosHeader()
  );

export const removeItem = (cartId, sku, useLoyaltyPoints) => {
  if (useLoyaltyPoints) {
    return axios.delete(
      `${getV1RootUrl()}/cart/${cartId}/item/${sku}?useLoyaltyPoints=true`,
      publicAxiosHeader()
    );
  }
  return axios.delete(
    `${getV1RootUrl()}/cart/${cartId}/item/${sku}`,
    publicAxiosHeader()
  );
};

export const updateItem = (cartId, sku, item) =>
  axios.put(
    `${getV1RootUrl()}/cart/${cartId}/item/${sku}`,
    item,
    publicAxiosHeader()
  );

export const addCouponOrGiftCard = (cartId, promocode) =>
  axios.post(
    `${getV1RootUrl()}/cart/${cartId}/coupon-or-gift-card`,
    promocode,
    publicAxiosHeader()
  );
